import Vue from "vue";
import Vuex from "vuex";

import atendimentoContext from "./atendimentoContext/index";
import { AtendimentoContextState } from "./atendimentoContext/types";
import fastActionStore, { FastActionMutations, FastActionState } from "./fastActionStore";
import manipulacaoContext, { ManipulacaoContextGetters } from "./manipulacaoContext/index";
import { ManipulacaoContextState } from "./manipulacaoContext/types";
import manipulacaoContextNew, { ManipulacaoContextNewGetters } from "./manipulacaoContextNew/index";
import { ManipulacaoContextNewState } from "./manipulacaoContextNew/types";
import nfeContext, { NfeContextMutations, NfeContextState } from "./nfeContext";
import notificationStore, { NotificationStoreMutations, NotificationStoreState } from "./notificationStore";
import paginationStatus, { PaginationStatusMutations, PaginationStatusState } from "./paginationStatusStore";
import sessionStore, { SessionGetters, SessionMutations, SessionState } from "./sessionStore";

Vue.use(Vuex);

export { SessionActions } from "./sessionStore";

export type AppState = {
    fastAction: FastActionState;
    paginationStatus: PaginationStatusState;
    session: SessionState;
    notification: NotificationStoreState;
    nfeContext: NfeContextState;
    manipulacaoContext: Map<string, ManipulacaoContextState>;
    manipulacaoContextNew: Map<string, ManipulacaoContextNewState>;
    atendimentoContext: AtendimentoContextState;
};

type Mutation =
    | FastActionMutations
    | PaginationStatusMutations
    | SessionMutations
    | NotificationStoreMutations
    | NfeContextMutations;

export type Mutations = Mutation[];

type Getter = SessionGetters | ManipulacaoContextGetters | ManipulacaoContextNewGetters;

export type Getters = Getter[];

export default new Vuex.Store<AppState>({
    modules: {
        fastAction: fastActionStore,
        paginationStatus: paginationStatus,
        session: sessionStore,
        notification: notificationStore,
        nfeContext: nfeContext,
        manipulacaoContext,
        manipulacaoContextNew,
        atendimentoContext,
    },
});
